const initialProduct = {
    brandsdropdown : [],
    categoriesdropdown : [],
    producttypesdropdown : [],
    products: [],
    getallproducts : [],
    productmessages:{}
};

const productReducer = (product = initialProduct, action) => {
    switch (action.type) {
        case 'GET_BRAND':
          return {
            ...product, brandsdropdown: action.payload.data
        };
        case 'GET_CATEGORY':
          return {
            ...product, categoriesdropdown: action.payload.data
        };
        case 'GET_PRODUCT_TYPE':
          return {
            ...product, producttypesdropdown: action.payload.data
        };
        case 'GET_PRODUCT':
          return {
              ...product, products: action.payload.data
          };
        case 'GET_ALL_PRODUCT':
          return {
              ...product, getallproducts: action.payload.data
          };
        case "ADD_PRODUCT":
          return {
            ...product, productmessages: action.payload.data
        };
        case 'UPDATE_PRODUCT':
          return {
            ...product, productmessages: action.payload.data
        };
        case 'PRODUCT_STATUS':
          return {
            ...product, productmessages: action.payload.data
        };
        
          default:
            return product;
    }
}
export default productReducer;